export enum PackageOrderStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING',
  SENT = 'SENT',
  DRAFT = 'DRAFT',
  SENT_TO_REQUESTOR = 'SENT_TO_REQUESTOR',
  PENDING_APPLICANT = 'PENDING_APPLICANT',
  INVITE_EXPIRED = 'INVITE_EXPIRED',
}

export enum PackageOrderItemStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}
